module.exports = __webpack_public_path__ + "img/Christmas-button.d6d3ed6.png";